/*
 *  Service Workbench DCV Integration - RACE Hub
 *  Created by: Dale A. Osborne, 2024
 *  Copyright RMIT University
 */
import React from 'react';
import { decorate, computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Table } from 'semantic-ui-react';

import ScEnvironmentAdsConnectionRow from './ScEnvironmentAdsConnectionRow';

// expected props
// - environment (via prop)
class ScEnvironmentAdsConnections extends React.Component {
  get environment() {
    return this.props.scEnvironment;
  }

  get isAppStreamEnabled() {
    return process.env.REACT_APP_IS_APP_STREAM_ENABLED === 'true';
  }

  render() {
    const env = this.environment;
    const state = env.state;
    const canConnect = state.canConnect;

    if (!canConnect) return null;
    let content = null;

    content = this.renderConnections();

    return <div className="fadeIn animated">{content}</div>;
  }

  renderConnections() {
    const env = this.environment;

    return (
      <div className="mt2 mb2 fadeIn animated">
        {this.isAppStreamEnabled && this.renderAppStreamInfo()}
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan="1">Testbed Connections</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <ScEnvironmentAdsConnectionRow scEnvironment={env} hasDcv={this.props.hasDcv} />
          </Table.Body>
        </Table>
      </div>
    );
  }
}

// see https://medium.com/@mweststrate/mobx-4-better-simpler-faster-smaller-c1fbc08008da
decorate(ScEnvironmentAdsConnections, {
  environment: computed,
});

export default inject()(withRouter(observer(ScEnvironmentAdsConnections)));
